module.exports = __webpack_public_path__ + "img/swe.40953a48.png";